import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const ADMIN_AFFILIATE_TRACKERS_FIXED_PAYMENTS_MAIN_ROUTE_NAME = Symbol('admin.affiliates.approved.trackers-settings.main-fixed-payments');
export const ADMIN_AFFILIATE_TRACKERS_FIXED_PAYMENTS_ROUTE_NAME = Symbol('admin.affiliates.approved.trackers-settings.fixed-payments');
export const TRANSLATION_GROUP_AFFILIATES_TRACKERS_SETTINGS_FIXED_PAYMENTS = Symbol('admin.affiliates.approved.trackers-settings.fixed-payments');

export const AFFILIATE_TRACKER_FIXED_PAYMENT_QUERY = 'affiliate.show-fixed-payment-data';
export const AFFILIATE_TRACKER_FIXED_PAYMENT_API_URL = 'admin/affiliates/:id/trackers/:trackerId/show_fixed_payment_data';

export const AFFILIATE_TRACKERS_UPDATE_FIXED_PAYMENTS_MUTATION = 'affiliate-trackers.update-fixed-payments';
export const AFFILIATE_TRACKERS_UPDATE_FIXED_PAYMENTS__API_URL = 'admin/affiliates/:affiliateId/trackers/:trackerId/update_fixed_payment';

export const AFFILIATE_TRACKER_FIXED_PAYMENTS_HISTORY_DELETE_MUTATION = 'affiliate.delete-history-fixed-payments';
export const AFFILIATE_TRACKER_FIXED_PAYMENTS_HISTORY_DELETE_API_URL = 'admin/history_of_fixed_payments_changes/:itemId';

export const AFFILIATES_APPROVED_FIXED_PAYMENTS_PERMISSIONS = {
  HISTORY_CHANGES_EDIT: new Permission(
    PermissionsList.admin.HISTORY_OF_FIXED_PAYMENTS_CHANGES_EDIT,
  ),
  HISTORY_CHANGES_DELETE: new Permission(
    PermissionsList.admin.HISTORY_OF_FIXED_PAYMENTS_CHANGES_DELETE,
  ),
};
